import { render, staticRenderFns } from "./UserInfoNewPopup.vue?vue&type=template&id=15c1c961&scoped=true&"
import script from "./UserInfoNewPopup.vue?vue&type=script&lang=js&"
export * from "./UserInfoNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoNewPopup.vue?vue&type=style&index=0&id=15c1c961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1c961",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VIcon,VRadio,VRadioGroup,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c1c961')) {
      api.createRecord('15c1c961', component.options)
    } else {
      api.reload('15c1c961', component.options)
    }
    module.hot.accept("./UserInfoNewPopup.vue?vue&type=template&id=15c1c961&scoped=true&", function () {
      api.rerender('15c1c961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/modal/UserInfoNewPopup.vue"
export default component.exports